/**
 * Plaatplan mark: een standaardplaat met drie panelen (zaagindeling).
 * Zelfde motief in header, favicon en PWA-iconen.
 */
export function PlaatplanLogo({ size = 38, className = "", title = "Plaatplan" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <rect width="40" height="40" rx="11" fill="#F0E6D2" />
      <rect
        x="0.75"
        y="0.75"
        width="38.5"
        height="38.5"
        rx="10.25"
        stroke="#D4C4A8"
        strokeWidth="1.5"
      />
      {/* Panelen met kerf (sheet-kleur tussen de stukken) */}
      <rect x="7" y="7" width="14.5" height="18.5" rx="2" fill="#0A9185" />
      <rect x="23.5" y="7" width="9.5" height="10.5" rx="2" fill="#F26B3A" />
      <rect x="23.5" y="19.5" width="9.5" height="13.5" rx="2" fill="#17A094" />
    </svg>
  );
}
